/**
 * Error Reducer
 */
import { Actions } from "components/Error/store/Actions";
import { Reducer } from "redux";
import { IErrorMessageProps } from "root/store/CajitaStore";
import { IErrorActionCreator } from "types/error_action_creator";

const initialState: IErrorMessageProps = {
  hidden: true,
  errorType: "connection",
  message: "",
};

const ErrorReducer: Reducer<IErrorMessageProps, IErrorActionCreator> = (
  state: IErrorMessageProps = initialState,
  action: IErrorActionCreator
): IErrorMessageProps => {
  if (action.type === Actions.SET_ERROR_MESSAGE)
    return {
      ...state,
      message: action.message as string,
      hidden: false,
    };

  if (action.type === Actions.HIDE_ERROR)
    return {
      ...state,
      hidden: true,
    };

  return state;
};

export { ErrorReducer };



// WEBPACK FOOTER //
// ./src/components/Error/store/Reducer.tsx